module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row-container"
  }, [_c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Land:")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.countries,
      "multiple": "true",
      "placeholder": "Selecteer een land",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verkoopkanaal:")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "true",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": function($event) {
        _vm.refresh()
      }
    },
    model: {
      value: (_vm.selectedSalesChannel),
      callback: function($$v) {
        _vm.selectedSalesChannel = $$v
      },
      expression: "selectedSalesChannel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Periode van")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPeriodFrom),
      expression: "selectedPeriodFrom"
    }],
    staticClass: "field-select form-control",
    staticStyle: {
      "height": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.selectedPeriodFrom)
    },
    on: {
      "change": function($event) {
        _vm.refresh()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPeriodFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Periode tot:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPeriodTo),
      expression: "selectedPeriodTo"
    }],
    staticClass: "field-select form-control",
    staticStyle: {
      "height": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.selectedPeriodTo)
    },
    on: {
      "change": function($event) {
        _vm.refresh()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPeriodTo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('api-table-block', {
    ref: "ordersTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "profit",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "order_number",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.orders_id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "total_sale_price",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "purchase_price",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "sales_channel_commision",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "shipping_cost",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "profit",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("money")(parseFloat(data.value))) + "\n    ")]
      }
    }, {
      key: "profit_percentage",
      fn: function(data) {
        return [(data.value >= 30) ? _c('b', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 30 && data.value >= 0) ? _c('b', {
          staticClass: "text-warning"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e(), _vm._v(" "), (data.value < 0) ? _c('b', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(data.value + '%'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale inkoopkosten: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_purchase_price))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale commissiekosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_commission))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale verzendkosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_shipping_cost))])]), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.total_costs))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Totale omzet: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("€ " + _vm._s(_vm.total_revenue))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Gemiddelde winstpercentage")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v(_vm._s(parseFloat(_vm.average_profit_percentage).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.total_profit))])])])])]), _vm._v(" "), (_vm.detailModalOrderId) ? _c('order-detail-modal', {
    key: _vm.detailModalOrderId,
    attrs: {
      "order-id": _vm.detailModalOrderId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderId = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Kosten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totale kosten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Opbrengsten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totale winst")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe7d8de4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/reports/PurchasingValuesOrdersPage.vue
// module id = 765
// module chunks = 1